"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M9.705 1.684a.5.5 0 0 1 .707 0l2.122 2.122a.5.5 0 0 1 0 .707l-2.122 2.121a.5.5 0 0 1-.707-.707l1.347-1.347c-1.264.07-2.558.68-3.63 1.56a7.5 7.5 0 0 0 4.592 13.295.5.5 0 0 1-.022 1A8.5 8.5 0 0 1 6.788 5.367c1.147-.942 2.606-1.67 4.113-1.78L9.705 2.391a.5.5 0 0 1 0-.707m9.49 6.375a.5.5 0 0 1 .666.237c.416.878.682 1.827.778 2.808a.5.5 0 0 1-.995.098 7.5 7.5 0 0 0-.687-2.478.5.5 0 0 1 .238-.666m.841 5.469a.5.5 0 0 1 .354.613 8.5 8.5 0 0 1-1.142 2.52.5.5 0 1 1-.832-.556 7.5 7.5 0 0 0 1.008-2.223.5.5 0 0 1 .612-.354m-6.012 6.211a.5.5 0 0 1 .333-.624 7.5 7.5 0 0 0 2.555-1.358.5.5 0 0 1 .63.776 8.5 8.5 0 0 1-2.895 1.54.5.5 0 0 1-.623-.334"
}), 'RotateRight');
//# sourceMappingURL=index.js.map